var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.048,
    height: 23.048,
    viewBox: "0 0 23.048 23.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-interface-symbol",
    transform: "translate(-0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34__4_",
    transform: "translate(0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M22.836,21.795l-5.951-5.856a9.412,9.412,0,0,0,2.516-6.4A9.622,9.622,0,0,0,9.7,0a9.621,9.621,0,0,0-9.7,9.543,9.621,9.621,0,0,0,9.7,9.543,9.752,9.752,0,0,0,6.1-2.131l5.974,5.879a.754.754,0,0,0,1.055,0A.727.727,0,0,0,22.836,21.795ZM9.7,17.618A8.141,8.141,0,0,1,1.5,9.543,8.141,8.141,0,0,1,9.7,1.468a8.141,8.141,0,0,1,8.205,8.075A8.141,8.141,0,0,1,9.7,17.618Z",
    transform: "translate(-0.006)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.85065cb0785247f302d0ce3d2c03da37.svg";
export { ForwardRef as ReactComponent };